module.exports = __webpack_public_path__ + "img/loginLogo.477e4488.svg";